<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M17.7906 3.92041L14.0805 0.210367C13.8 -0.0699346 13.3462 -0.0701456 13.0656 0.209874L1.38495 11.8669C1.29087 11.9607 1.22456 12.079 1.1937 12.2082L0.0208471 17.1151C-0.0370905 17.3575 0.0352261 17.6132 0.211605 17.7896C0.347801 17.9258 0.531141 18 0.719298 18C0.775056 18 0.831095 17.9933 0.886114 17.9801L5.79299 16.8073C5.92226 16.7764 6.04049 16.7104 6.13432 16.616L17.7911 4.93531C18.0711 4.65479 18.0709 4.20047 17.7906 3.92041ZM5.2616 15.4578L1.68965 16.3116L2.54321 12.7396L13.5726 1.73316L16.2681 4.4286L5.2616 15.4578Z" class="icon-fill"/>
      <path d="M11.3266 2.93927L10.3113 3.95459L14.0449 7.68822L15.0602 6.6729L11.3266 2.93927Z" class="icon-fill"/>
      <path d="M12.1776 4.80621L3.20233 13.7815L4.21765 14.7968L13.1929 5.82153L12.1776 4.80621Z" class="icon-fill"/>
      <path d="M2.37451 11.9153L1.35919 12.9307L5.06913 16.6406L6.08445 15.6253L2.37451 11.9153Z" class="icon-fill"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="18" height="18" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'pencil'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>